import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { FeatureTogglesFacade, FeatureToggleType } from '@cigna/features';
import { filter, take } from 'rxjs/operators';

/**
 * ChatResolver provides a way for the application to request omnibus operation which provides more details
 *
 * **Route Configuration:**
 * ```ts
 *  {
 *    resolve: {
 *      chat: ChatResolver,
 *    }
 *  }
 * ```
 */
@Injectable({ providedIn: 'root' })
export class ChatResolver implements Resolve<boolean> {
  constructor(private featureFacade: FeatureTogglesFacade) {}

  resolve(): Observable<boolean> {
    this.featureFacade
      .featuresEnabled(['chat'])
      .pipe(
        filter((featureFlag) => !!featureFlag),
        take(1),
      )
      .subscribe(() => {
        this.featureFacade.updateFeatureToggles(
          {
            canCallOmnibusApi: true,
          },
          FeatureToggleType.PERMISSION,
        );
      });
    return of(true);
  }
}
